// 9fbef606107a605d69c0edbcd8029e5d
import { ACCESSORIES_CONSTANTS } from './Accessories.constants';

export const setAccessoriesLoader = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.ACCESSORIES_LOADER,
    payload,
  };
};

export const setSecondaryAccessoriesLoader = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SECONDARY_ACCESSORIES_LOADER,
    payload,
  };
};

export const getAccessoriesFromIds = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.FETCH_ACCESSORIES_FROM_IDS,
    payload,
  };
};

export const getProductDetailById = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.FETCH_PRODUCTDETAIL_BY_ID,
    payload,
  };
};

export const setSecondaryAccessoryDetail = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SET_SECONDARY_ACCESSORY_DETAIL,
    payload,
  };
};

export const getSecondaryAccessoriesFromIds = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.FETCH_SECONDARY_ACCESSORIES_FROM_IDS,
    payload,
  };
};

export const setAccessories = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SET_ACCESSORIES,
    payload,
  };
};

export const clearAllSelectedAccessories = () => ({
  type: ACCESSORIES_CONSTANTS.CLEAR_SELECTED_ACCESSORIES,
});

export const setSecondaryAccessories = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SET_SECONDARY_ACCESSORIES,
    payload,
  };
};

export const setClickedAccessory = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SET_CLICKED_ACCESSORY,
    payload,
  };
};

export const setSecondaryClickedAccessory = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SET_SECONDARY_CLICKED_ACCESSORY,
    payload,
  };
};

export const removeClickedAccessory = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.REMOVE_CLICKED_ACCESSORY,
    payload,
  };
};

export const removeSecondaryAccessory = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.REMOVE_SECONDARY_ACCESSORY,
    payload,
  };
};

export const replaceAccessory = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.REPLACE_ACCESSORY,
    payload,
  };
};

export const replaceSecondaryAccessory = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.REPLACE_SECONDARY_ACCESSORY,
    payload,
  };
};

export const autoIncrementAccessary = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.AUTO_INCREMENT_ACCESSORY,
    payload,
  };
};

export const storeParentProductQty = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.PARENT_PRODUCT_QTY_CHNG,
    payload,
  };
};

export const setParentAccessory = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SET_PARENT_ACC,
    payload,
  };
};

export const setCustomType = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SET_PARENT_CUSTOMIZATION_TYPE,
    payload,
  };
};
export const setUpdateType = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SET_UPDATE_TYPE,
    payload,
  };
};

export const set0007Error = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SET_SHOW_0007_ERROR,
    payload,
  };
};

export const setAllowMultipleSelect = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SET_ALLOW_MULTIPLE_SELECT,
    payload,
  };
};

export const setCurrentHighlightedIndex = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SET_CURRENT_HIGHLIGHTED_INDEX,
    payload,
  };
};

export const resetSecondaryAccessoryDetails = () => {
  return {
    type: ACCESSORIES_CONSTANTS.RESET_SECONDARY_ACCESSORY_DETAIL,
  };
};

export const removeSecondaryAccessoriesWRTParentID = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.REMOVE_SECONDARY_ACCESSORY_WRT_PARENT_ID,
    payload,
  };
};

export const setTempSelectedSecondaryAccessories = () => {
  return {
    type: ACCESSORIES_CONSTANTS.SET_TEMPORARY_SECONDARY_SELECTED_ACCESSORIES,
  };
};

export const removeTempSelectedSecondaryAccessoriesWithPayload = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.REMOVE_SELECTED_TEMPORARY_SECONDARY_ACCESSORIES,
    payload,
  };
};

export const storeGrandParentId = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.GRAND_PARENT_ID,
    payload,
  };
};

export const accessorySizeErrorAction = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.SIZE_ERROR,
    payload,
  };
};

export const saveAccessoryGrandParentSizeAction = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.GRAND_PARENT_SIZE,
    payload,
  };
};

export const deselectSizeAction = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.DESELECT_SIZE,
    payload,
  };
};

export const storeGrandParentScreen = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.GRAND_PARENT_SCREEN,
    payload,
  };
};

export const saveAccessoryGrandParentColorAction = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.GRAND_PARENT_COLOR,
    payload,
  };
};

export const saveAccessoryGrandParentFitAction = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.GRAND_PARENT_FIT,
    payload,
  };
};

export const saveAccessoryGrandParentQuantityAction = (payload) => {
  return {
    type: ACCESSORIES_CONSTANTS.GRAND_PARENT_QUANTITY,
    payload,
  };
};

export const clearGrandParentDataAction = () => {
  return {
    type: ACCESSORIES_CONSTANTS.CLEAR_GRAND_PARENT_DATA,
  };
};
